// extracted by mini-css-extract-plugin
export default {"insuranceProgressBar":"insuranceProgressBar","insuranceProgressBar__fill":"insuranceProgressBar__fill"};